/**
 * Which parts of the assessment a clinic may run, set per vendor by the super
 * admin (Add / Edit Vendor → Scan sections).
 *
 * Stored on the vendors/{id} document:
 *
 *   scanSections: { footScan, plantar, legAlignment, bodyScan, footSize }   // booleans
 *
 * Only an explicit `false` turns a section off: a vendor created before this
 * existed has no map at all, and keeps every section. The super admin's own
 * account always has everything. The kiosk skips the screens of a section
 * that is off, and the rules (firestore.rules) stop a clinic switching its
 * own sections back on.
 *
 * This is the admin panel's JavaScript copy of KinetiQE/src/lib/scanSections.ts
 * — change both together.
 */

export const SCAN_SECTIONS = [
  { key: 'footScan', label: 'Foot scan', short: 'Foot', description: 'Podoscope camera scan of both feet' },
  { key: 'plantar', label: 'Plantar pressure', short: 'Plantar', description: 'KinetiQ pressure mat and its plantar pressure readings' },
  { key: 'legAlignment', label: 'Leg alignment', short: 'Leg', description: 'Leg photographs and lower-limb alignment analysis' },
  { key: 'bodyScan', label: 'Body scan', short: 'Body', description: 'Full-body photographs and posture analysis' },
  // Not a screen of its own: a measurement on the kiosk's foot scan screen.
  { key: 'footSize', label: 'Foot size measurement', short: 'Size', description: 'Foot length, width and shoe size from the podoscope camera' },
];

export const ALL_SECTIONS = { footScan: true, plantar: true, legAlignment: true, bodyScan: true, footSize: true };

/** The sections a vendor record allows. Missing or non-false means allowed. */
export function scanSectionsOf(vendor) {
  if (!vendor || vendor.isSuperAdmin === true) return { ...ALL_SECTIONS };
  const map = vendor.scanSections && typeof vendor.scanSections === 'object' ? vendor.scanSections : {};
  const out = { ...ALL_SECTIONS };
  SCAN_SECTIONS.forEach(({ key }) => { out[key] = map[key] !== false; });
  return out;
}

export function enabledCount(sections) {
  return SCAN_SECTIONS.filter(({ key }) => sections[key]).length;
}
